import LetterPage from '../../components/LetterPage';

export default function CompletedLetter() {
  return <LetterPage editFeat={false} completedLetterPage={true} />;
}
